import request from '@/utils/request';
import qs from 'qs'
import axios from 'axios'
let _this = this
// 图文搜题
export function questionSearch(data) {
    return request({
        url: '/question/search',
        method: 'post',
        data
    })
}
// 举一反三
export function recommendSearch(data) {
    return request({
        url: '/question/recommend',
        method: 'post',
        data
    })
}


// 知识点搜题
export function knowledgeSearch(data) {
    return request({
        url: '/question/pick',
        method: 'post',
        data
    })
}

// 知识点推题
export function pushSearch(data) {
    return request({
        url: '/question/push',
        method: 'post',
        data
    })
}


// 获取试题详情
export function detailQuestion(params) {
    return request({
        url: '/question/detail',
        method: 'get',
        params
    })
}




// 将试题添加到试题篮
export function questionAdd(data) {
    return request({
        url: '/basket/question/add',
        method: 'post',
        data
    })
}
// 批量获取试题详情
export function detailsAdd(data) {
    return request({
        url: '/question/details',
        method: 'post',
        data
    })
}
// 将试题从试题篮中删除
export function questionDelete(data) {
    return request({
        url: '/basket/question/delete',
        method: 'post',
        data
    })
}
// 获取试题列表
export function questionList(params) {
    return request({
        url: '/basket/question/list',
        method: 'get',
        params
    })
}





// 创建试卷
export function createPaper(data) {
    return request({
        url: '/paper/create',
        method: 'post',
        data
    })
}


// 编辑试卷
export function editPaper(data) {
    return request({
        url: '/paper/edit',
        method: 'post',
        data
    })
}
// 删除试卷
export function deletePaper(data) {
    return request({
        url: '/paper/delete',
        method: 'post',
        data
    })
}
// 将试题添加到试卷
export function addPaper_question(data) {
    return request({
        url: '/paper/question/add',
        method: 'post',
        data
    })
}
// 将试题从试卷中删除
export function deletePaper_question(data) {
    return request({
        url: '/paper/question/delete',
        method: 'post',
        data
    })
}




// 获取试卷详情
export function detailPaper(params) {
    return request({
        url: '/paper/detail',
        method: 'get',
        params
    })
}
// 获取试卷列表
export function listPaper(params) {
    return request({
        url: '/paper/list',
        method: 'get',
        params
    })
}
// 下载试卷/解析
export function downloadPaper(params) {
    return request({
        responseType: 'blob',
        url: '/paper/download',
        method: 'get',
        'content-type': 'application/octet-stream',
        params
    })
}

// 生成试卷/解析
export function generatePaper(params) {
    return request({
        url: '/paper/generate',
        method: 'get',
        params
    })
}


// 获取试卷缩略图
export function thumbnailPaper(params) {
    return request({
        // 
        url: '/paper/thumbnail/1',
        method: 'get',

        params
    })
}
// 获取试卷缩略图
export function previewPaper(params) {
    return request({
        // 
        url: '/paper/preview',
        method: 'get',
        // responseType:'blob',
        params
    })
}




// 创建会话
export function conversation_create(data) {
    return request({
        url: '/chat/conversation',
        method: 'post',
        data
    })
}
// 作文批改(拍照)
export function conversation_correct(data) {
    return request({
        url: '/chat/correct',
        method: 'post',
        data
    })
}

// // 作文批改(手动上传)
// export function conversation_correct(data) {
//     return request({
//         url: '/chat/correct',
//         method: 'post',
//         data
//     })
// }



// AI解析
export function resolvingAi(data) {
    return request({
        url: '/chat/ai/resolving',
        method: 'post',
        data
    })
}

// 批量OCR识别
export function conversation_ocr(data) {
    return request({
        url: '/basic/ocr',
        method: 'post',
        data
    })
}
// AI解题
export function solvingAi(data) {
    return request({
        url: '/chat/ai/solving',
        method: 'post',
        data
    })
}


// 生成口算试卷
export function mentalCalculation(data) {
    return request({
        url: '/calculation/mental/gen',
        method: 'post',
        data
    })
}

// 生成竖式计算试卷
export function verticalCalculation(data) {
    return request({
        url: '/calculation/vertical/gen',
        method: 'post',
        data
    })
}


// 视频解析
export function resolveVideo(data, cancelToken) {
    return request({
        url: '/video/resolve',
        method: 'post',
        data,
        cancelToken: cancelToken
    })
}


// 获取视频详情
export function detailVideo(params) {
    return request({
        // 
        url: '/video/detail',
        method: 'get',

        params
    })
}
// 获取视频列表
export function listVideo(params) {
    return request({
        // 
        url: '/video/list',
        method: 'get',

        params
    })
}


